/**
 * @congress/auth-helper v1.0.0
 * @version 1.0.0
 * @license CYIM: www.cyim.com
 */

import AuthType from './AuthType.enum.js';
class ClientService {
  /**
   * Default constructor & use cyim token
   * @constructor CyimService
   * @param {string} token - Custom token
   * @throws {"A token is required !"}
   */
  constructor(token) {
    if (!token) {
      throw "A token is required !";
    }
    this.type = AuthType.CLIENT;
    this._token = token;
    this._tokenParsed = this._decodeToken(this._token);
  }

  /**
   * Decode JWT Token
   * @param str
   * @returns {null | string}
   * @private
   */
  _decodeToken(str) {
    let token = null;
    try {
      if (str) {
        str = str.split(".")[1];
        str = str.replace(/-/g, "+");
        str = str.replace(/_/g, "/");
        switch (str.length % 4) {
          case 0:
            break;
          case 2:
            str += "==";
            break;
          case 3:
            str += "=";
            break;
          default:
            throw new Error("Invalid token");
        }
        str = decodeURIComponent(escape(window.atob(str)));
        token = JSON.parse(str);
      }
    } catch (err) {
      console.error("Failed to decode token:", err);
    }
    return token;
  }

  /**
   * Always true with CYIM account.
   * @returns {boolean}
   */
  isAuthenticated() {
    return true;
  }

  /**
   * CYIM token never expires
   * @returns {boolean}
   */
  isTokenExpired() {
    return false;
  }

  /**
   * The base64 encoded token that can be sent in the Authorization header in requests to services.
   * @returns {string|null|*}
   */
  getToken() {
    return this._token;
  }

  /**
   * The parsed token as a JavaScript object.
   * @returns {null|string|*}
   */
  getTokenParsed() {
    return this._tokenParsed;
  }
}
export { ClientService as default };
//# sourceMappingURL=ClientService.js.map
